import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { isEmpty } from 'helpers/ramda';
import { populatePriceMovement } from 'reducers/helpers/trade';
import type { AggTradesPayload } from 'types/RecentTrades';

import type { RecentTradesStore } from './recentTrades.types';

const useRecentTradesStoreBase = create<RecentTradesStore>()(
  devtools(
    set => ({
      // #region state
      state: {
        trades: [],
        lastTrade: undefined,
      },
      // #endregion

      // #region actions
      actions: {
        updateRecentTrades: (
          payload: AggTradesPayload,
          selectedProductSymbol: string
        ) => {
          set(
            store => {
              try {
                // Early return if symbols don't match or payload is invalid
                if (payload.sy !== selectedProductSymbol) {
                  return store;
                }

                const currentTrades = store.state.trades;
                const currentLastTrade = store.state.lastTrade;

                const aggTrades = payload.f;
                const trades = populatePriceMovement(aggTrades, currentLastTrade);
                const newTrades = isEmpty(currentTrades)
                  ? trades
                  : [...trades, ...currentTrades].slice(0, 50);

                return {
                  state: {
                    ...store.state,
                    trades: newTrades,
                    lastTrade: trades[0],
                  },
                };
              } catch (error) {
                console.error('DEBUG updateRecentTrades', error);
                return store;
              }
            },
            false,
            'updateRecentTrades'
          );
        },
        resetTrades: () => {
          set(
            store => ({
              state: {
                ...store.state,
                trades: [],
                lastTrade: undefined,
              },
            }),
            false,
            'resetTrades'
          );
        },
      },
      // #endregion
    }),
    {
      name: 'RecentTradesStore',
    }
  )
);

export { useRecentTradesStoreBase };
